module.exports = __webpack_public_path__ + "img/paypal.56ef1f12.png";